import React, { Component } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import './Navigation.css';
import SectionSeparator from "./Section-Separator";

class Navigation extends Component {
    render() {
        return (
            <div>
                <Navbar expand="lg">
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center">
                        <Nav>
                            <LinkContainer exact={"true"} to="/"><Nav.Link>Home</Nav.Link></LinkContainer>
                            <LinkContainer to="/about"><Nav.Link>About</Nav.Link></LinkContainer>
                            <LinkContainer to="/seasonal"><Nav.Link>Seasonal</Nav.Link></LinkContainer>
                            <LinkContainer to="/sugar-cookies"><Nav.Link>Sugar Cookies</Nav.Link></LinkContainer>
                            <LinkContainer to="/macarons"><Nav.Link>Macarons</Nav.Link></LinkContainer>
                            {/* <LinkContainer to="/cakes"><Nav.Link>Cakes</Nav.Link></LinkContainer> */}
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>

                <div className="bottom-padding">
                    <SectionSeparator />
                </div>
            </div>
        );
    }
}

export default Navigation;